import React, { useEffect, useState } from "react"
import {
    useTemplateEngine,
    useTypeWriter,
    useLinebreak,
    useCLI,
    LinebreakStrategy,
    useScroll,
    soundboard,
    HugoStateApi,
    expressions,
    useCryptWriter,
    useButton,
} from "../hugo"
import welcome from './welcome.hugo'
import hackedWelcome from './hackedWelcome.hugo'
import booting from './booting.hugo'
import languages from './languages.hugo'
import hobbies from './hobbies.hugo'
import idle from './idle.hugo'
import { useLocation, useNavigate } from "react-router-dom"
import soundbord from "../hugo/soundboard"
import { RowAlign } from "../hugo/templateEngine"


enum BootState {
    Loaded = -1,
    Idle = 0,
    Booting = 1,
    Booted = 2,
    Done = 3,
    Ignore = 99,
}

const useStartpageHugo = (hugoApi: HugoStateApi): [(command: string) => void, boolean] => {
    const [bootState, setBootState] = useState<BootState>(-1)
    const [hacked, setHacked] = useState<boolean>(false)
    const [lastCommand, setLastCommand] = useState<string | null>(null)
    const render = useTemplateEngine();
    const typewriter = useTypeWriter({})
    const crypeWriter = useCryptWriter({ speed: 5 })
    const crypeWriterFast = useCryptWriter({ speed: 10 })
    const linebreak = useLinebreak({ strategy: LinebreakStrategy.Word })
    const scroll = useScroll({})
    const location = useLocation()
    const navigate = useNavigate()
    const [bootButton] = useButton({
        label: ' Boot',
        onClick: () => {
            setBootState(BootState.Booting);
        },
        position: {x: 11, y: 8 },
        visible: true,
    })
    const cli = useCLI({
        onSubmit: (value: string | null) => {
            setBootState(currentBootState => {
                switch (currentBootState) {
                    case BootState.Done:
                        setLastCommand(value)
                        return currentBootState
                    default:
                        return currentBootState
                }
            })
        },
        onEmptySubmit: () => {
            setBootState(currentBootState => {

                hugoApi.cancleTTS()
                switch (currentBootState) {
                    case BootState.Idle:
                        return BootState.Booting
                    case BootState.Done:
                        // Lets remove shaders on command to reveal full text log
                        soundbord.error()
                        hugoApi.setShaders([cli])
                        return currentBootState
                    default:
                        return currentBootState
                }
            })

        }
    })

    const commands = {
        cv: () => {
            const waitingSound = soundboard.waiting()
            hugoApi.output(render(expressions.loading), { append: false, shaders: [crypeWriter] })
            hugoApi.output(render(`Please be patient, I am searching for the correct bytes[ ,.,.,.][ , ,.,.][ , , ,.]`, {}, { orientation: RowAlign.Center, resolution: hugoApi.getResolution() }), { plugins: [scroll, linebreak], append: true, shaders: [crypeWriter], tts: true })
            setTimeout(() => {
                waitingSound.pause()
                soundboard.success()

                hugoApi.output(render(expressions.smile), { append: false, shaders: [] })
                hugoApi.replaceLastRow(render(`Here we go!`, {}, { orientation: RowAlign.Center, resolution: hugoApi.getResolution() })[0], true)
                setTimeout(() => {
                    hugoApi.addRow(render(`Processing CV[ ,.,.,.][ , ,.,.][ , , ,.]`, {}, { orientation: RowAlign.Center, resolution: hugoApi.getResolution() })[0])
                    setTimeout(() => {
                        hugoApi.replaceLastRow(render(`Done! Redirecting[ ,.,.,.][ , ,.,.][ , , ,.]`, {}, { orientation: RowAlign.Center, resolution: hugoApi.getResolution() })[0])
                        setTimeout(() => {
                            navigate('/cv', { state: 'hugo' })
                        }, 1000)
                    }, 1000)
                }, 1000)
            }, 5000)
        },
        contact: () => { navigate('/contact', { state: 'hugo' }) },
        hobbies: () => {
            hugoApi.output(render(hobbies), { plugins: [linebreak, scroll], shaders: [cli], tts: true, append: true })
        },
        languages: () => {
            hugoApi.output(render(languages), { plugins: [linebreak, scroll], shaders: [cli], tts: true, append: true })
        },
        help: () => {
            hugoApi.output(render(
                `All Commands:\n"${[...Object.keys(commands), ...Object.keys(hiddenCommands)].sort().join('", "')}"`
            ), { plugins: [linebreak, scroll], append: true, shaders: [cli], tts: true })
        }
    }

    const hiddenCommands = {
        hugo: () => {
            hugoApi.output(render(
`I am Hugo, an Application Assisten System written in Typescript by Alexander Mührenberg. My Hobbies are:
- Searching for a purpose
- Getting Alex a new Job`
            ), { plugins: [linebreak, scroll], shaders: [cli], tts: true })
        },
        exit: () => {
            hugoApi.output(render(`Goodby!`), { plugins: [linebreak, scroll], shaders: [cli], tts: true })
            setTimeout(() => {
                setBootState(BootState.Idle)
            }, 500)
        },
        joke: () => {
            hugoApi.output(render(`How many programmers does it take to change a light bulb?\nNone. It’s a hardware problem.`), { plugins: [linebreak, scroll], shaders: [cli], tts: true })
        },
        clear: () => {
            hugoApi.output(render(`Let me get a Broom![ ,.,.,.][ , ,.,.][ , , ,.]`), { plugins: [linebreak, scroll], shaders: [cli] })
            setTimeout(() => {
                hugoApi.clear()
                hugoApi.setShaders([cli])
            }, 1000)

        },
        music: () => {
            hugoApi.output(render(`Let me show you a Song by hugo!`), { plugins: [linebreak, scroll], shaders: [cli], tts: true })
            setTimeout(() => {
                navigate('/_music', { state: 'hugo' })
            }, 1000)
        },
        game: () => {
            hugoApi.output(render(`Let's have some fun!`), { plugins: [linebreak, scroll], shaders: [cli], tts: true })
            setTimeout(() => {
                navigate('/game/_breakout', { state: 'hugo' })
            }, 1000)
        },
        login: (command: string) => {
            if (command === 'login Hugo1 12345') {
                hugoApi.output(render(`Hugos Authentication Provider: You are now logged in!`), { plugins: [linebreak, scroll], shaders: [cli], tts: true })
                setTimeout(() => {
                    setHacked(true)
                    setBootState(BootState.Ignore)
                    hugoApi.output(render(expressions.matrix), { plugins: [], shaders: [], tts: false, append: false })
                    setTimeout(() => { hugoApi.output(render(expressions.madInversed), { append: false, shaders: [] }) }, 8000)
                    setTimeout(() => { setBootState(BootState.Booting) }, 10000)
                    setTimeout(() => { 
                        hugoApi.output(render('SECURITY ALERT! Rebooting[ ,.,.,.][ , ,.,.][ , , ,.]'), { append: false, tts: true });
                        soundboard.error()
                    }, 8500)
                }, 2000)
            } else if (command === 'login Alex admin1') {
                hugoApi.output(render(`Hugos Authentication Provider: You are now logged in!`), { plugins: [linebreak, scroll], shaders: [cli], tts: true })
                setTimeout(() => {
                    setHacked(false)
                    setBootState(BootState.Ignore)
                    hugoApi.output(render(expressions.hireAlex), { plugins: [], shaders: [crypeWriterFast], tts: false, append: false })
                    soundboard.success()
                    setTimeout(() => { setBootState(BootState.Booted) }, 10000)
                }, 2000)
            } else if(command.split(' ').length === 3) {
                hugoApi.output(render(`Hugos Authentication Provider: Invalid Credentials!`), { plugins: [linebreak, scroll], shaders: [cli], tts: true })
            } else {
                soundboard.error()
                hugoApi.output(render(`Login command syntax: login [username] [password]`), { plugins: [linebreak, scroll], shaders: [cli], tts: false })
            }
        }
    }

    useEffect(() => {
        if (lastCommand === null || bootState !== BootState.Done) return
        hugoApi.cancleTTS()
        setLastCommand(null)
        hugoApi.output(render(`> ${lastCommand}`), { plugins: [linebreak, scroll], shaders: [cli] })
        switch (lastCommand.toLocaleLowerCase()) {
            case 'vita':
            case 'cv':
                commands.cv()
                return
            case 'contact':
            case 'kontakt':
                commands.contact()
                return
            case 'hobbies':
            case 'hobby':
            case 'interests':
                commands.hobbies()
                return
            case 'language':
            case 'languages':
            case 'speaks':
            case 'i18n':
                commands.languages()
                return
            case 'more':
            case 'help':
            case '?':
                commands.help()
                return
            case 'clear':
                hiddenCommands.clear()
                return
            case 'music':
            case 'musik':
                hiddenCommands.music()
                return
            case 'game':
            case 'breakout':
                hiddenCommands.game()
                return
            case 'joke':
                hiddenCommands.joke()
                return
            case 'hugo':
                hiddenCommands.hugo()
                return
            case 'login':
                hiddenCommands.login('')
                return
            case 'shutdown':
            case 'shut-down':
            case 'exit':
            case 'off':
                hiddenCommands.exit()
                return
        }
        switch (true) {
            case /hello/i.test(lastCommand):
                hugoApi.output(render(`Hello, nice to meet you!`), { plugins: [linebreak, scroll], shaders: [cli], tts: true })
                return
            case /test/i.test(lastCommand):
                hugoApi.output(render(`It's not a Turing Test, but I guess I passed it?`), { plugins: [linebreak, scroll], shaders: [cli], tts: true })
                return
            case /login/i.test(lastCommand):
                hiddenCommands.login(lastCommand)
                return
            case /hack/i.test(lastCommand):
                setBootState(BootState.Ignore)
                setHacked(true)
                hugoApi.output(render(expressions.blankInversed), { append: false, shaders: [crypeWriter] })
                setTimeout(() => { hugoApi.output(render(expressions.madInversed), { append: false, shaders: [] }) }, 3500)

                setTimeout(() => {
                    hugoApi.output(render('How dare you! Rebooting[ ,.,.,.][ , ,.,.][ , , ,.]'), { append: false, tts: true });
                    soundboard.error()
                }, 4000)

                setTimeout(() => {
                    setBootState(BootState.Booting)
                }, 5500)
                return
            default:
                soundboard.error()
                hugoApi.output(render(`Command "${lastCommand}" not found! (write "help" for command overview)`), { plugins: [linebreak, scroll], shaders: [cli] })
                return
        }
    }, [lastCommand, bootState])

    const setCommand = (command: string) => {
        if (bootState === BootState.Done) {
            setLastCommand(command)
        }
    }

    useEffect(() => {
        switch (bootState) {
            case BootState.Loaded:
                if (location.state === "hugo") {
                    setTimeout(() => { setBootState(BootState.Done) })
                } else {
                    setTimeout(() => { setBootState(BootState.Idle) })
                }
                break;
            case BootState.Idle:
                hugoApi.output(render(idle, { version: 'v0.1.0' }), { append: false, plugins: [bootButton] })
                break;
            case BootState.Booting:
                hugoApi.output(render(booting), { append: false })
                setTimeout(() => { setBootState(BootState.Booted) }, 2000)
                break;
            case BootState.Booted:
                soundboard.boot()
                hugoApi.output(render(expressions.smile), { append: false })
                setTimeout(() => { hugoApi.output(render(expressions.closeEyes), { append: false }) }, 1900)
                setTimeout(() => { setBootState(3) }, 3000)
                break;

            case BootState.Done:

                if (location.state === "hugo") {
                    hugoApi.output(
                        render(hacked ? hackedWelcome : welcome, { commands: Object.keys(commands).join(', ') }), {
                            plugins: [linebreak, scroll],
                            append: false,
                            shaders: [cli],
                        }
                    )
                } else {
                    hugoApi.output(
                        render(hacked ? hackedWelcome : welcome, { commands: Object.keys(commands).join(', ') }), {
                            plugins: [linebreak, scroll],
                            append: false,
                            shaders: [cli, typewriter],
                            tts: true,
                        }
                    )
                }

                break;

        }
    }, [bootState])

    return [setCommand, (bootState === BootState.Done)]
}

export default useStartpageHugo
